import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Home from 'screens/Home/Home';
import fetchAllCategories from 'utils/getAllCategories';
import fetchAllRooms from 'utils/getAllRooms';
import { ROUTES } from 'config/constants';
import { getAllProducts } from 'api/product';
import { Helmet } from 'react-helmet';
import { PUBLIC_PAGE_DEFAULT_DESC } from 'config/txt';

export default class DashboardContainer extends PureComponent {
    state = {
        categoryTypes: [],
        rooms: [],
        popularProducts: [],
        isLoading: true
    }

    async componentDidMount() {
        await Promise.all([
            fetchAllCategories().then(categories => {
                const filterArchiveCategory = ({ name }) => name?.toLowerCase() !== 'archive';

                this.setState({ categoryTypes: categories.filter(filterArchiveCategory) });
            }),
            fetchAllRooms().then(rooms => {
                this.setState({ rooms: rooms });
            }),
            getAllProducts({ popular: true }).then(({ data: { data } }) => {
                // console.log(data);
                this.setState({ popularProducts: data });
            })
        ]);

        this.setState({ isLoading: false });
    }

    navigateToRoom = ({ roomName }) => {
        const { history } = this.props;

        history.push(`${ROUTES.SELECTED_ROOM(roomName.toLowerCase())}`);
    }

    navigateToCategoryDetails = ({ categoryName }) => {
        const { history } = this.props;

        history.push(`${ROUTES.CATEGORY_DETAILS(categoryName)}`);
    }

    navigateToSearchPage = ({ text }) => {
        const { history } = this.props;

        history.push(`${ROUTES.SEARCH()}?search=${text.toLowerCase().replace(/ /g, '_')}`);
    }

    navigateToProductPage = slug => {
        const { history } = this.props;

        history.push(`${ROUTES.PUBLICPRODUCT(slug)}`);
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Products - Prism Medical UK, moving, handling and bathing solutions</title>
                    <meta name='description' content={PUBLIC_PAGE_DEFAULT_DESC} />
                </Helmet>
                <Home
                    navigateToRoom={this.navigateToRoom}
                    navigateToCategoryDetails={this.navigateToCategoryDetails}
                    navigateToSearchPage={this.navigateToSearchPage}
                    navigateToProductPage={this.navigateToProductPage}
                    {...this.state} />
            </>

        );
    }
}

DashboardContainer.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};
